import React from 'react'
import { useNavigate } from 'react-router-dom';
import landimage from "../../../assets/images/landimg.png"
export default function OwnerProjectCard({ projectData }) {
    const navigate = useNavigate();
    const handlePaymentDetails = (projectId) => {
        navigate("/ownerlandbyproject/" + projectId)
    }
    return (
        <div className="card " style={{ "width": "100%", border: "none" }}>
            <img
                src={
                    projectData.projectImageUrl
                        ? `${window.RealestateService}${projectData.projectImageUrl}`
                        : landimage
                }
                className="card-img-top p-3 project-img"
                alt="Project"
            />

            <div className="card-body pt-0">
                <div className='d-flex flex-row justify-content-between'>
                    <div className='d-flex flex-column pb-2'>
                        <h6 className="card-title" title={"Project Name"}>
                            {projectData.projectName}
                            <span className={`ms-2 badge bg-success`} title={"Total Land Area"}>
                                {projectData.landArea} {projectData?.unitName ? `( ${projectData?.unitName} )` : ''}
                            </span>
                            {/* <span style={{ fontSize: '12px', marginLeft: '5px' }}>{projectData.approvedBy ? `(${projectData.approvedBy})` : ''}</span> */}
                        </h6>
                        {/* <span className='card-refrence'>
                            {projectData.givenAmount}
                        </span> */}
                    </div>
                    {/* <div class="dropdown dropend">

                        <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                        <ul className="dropdown-menu mr-3">
                            <li><span className="dropdown-item" onClick={() => { handlePaymentDetails(projectData.id) }}>Payment Details</span></li>
                        </ul>
                    </div> */}
                </div>
                <div className="d-flex flex-row justify-content-between card-text pb-3 pt-1">
                    <div className='d-flex flex-row gap-2' title={"Given Amount"}>
                        <i class="fa-solid fa-indian-rupee-sign rupee-icon bg-success"></i>
                        <span className='price text-secondary'>{projectData.givenAmount}</span>
                    </div>
                    <div className='d-flex flex-row gap-2 ' title={"Pending Amount"}>
                        <i class="fa-solid fa-indian-rupee-sign rupee-icon bg-danger"></i>
                        <span className='price text-secondary'>{projectData.pendingAmount}</span>
                    </div>
                </div>
                <span className="btn btn-primary" onClick={() => { handlePaymentDetails(projectData.projectId) }}>Payment Details</span>

            </div>
        </div>
    )
}
